import { render } from "./ActiveScreen.vue?vue&type=template&id=36e024a6"
import script from "./ActiveScreen.vue?vue&type=script&lang=js"
export * from "./ActiveScreen.vue?vue&type=script&lang=js"

import "./ActiveScreen.vue?vue&type=style&index=0&id=36e024a6&lang=css"

import exportComponent from "/Users/peterdevos/Apps/clawmachine_zendesk/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__